<template>
  <div 
    v-if="($can(constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_CONSULTER) || $can(constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER))"
    class="
            border-1 rounded-xl shadow-md h-full
            flex flex-col-reverse 
            pt-10 md:py-0
        "
    :class="{
      'md:grid md:grid-cols-12 bg-white': position < 3,
      'col-span-2': position === 2,
      'bg-white md:bg-indigo-200 md:grid md:grid-cols-1 col-span-1 row-span-2': position === 3,
    }"
  >
    <!-- Button add + illustration -->
    <div 
      v-if="position > 1"
      class="
                relative flex flex-col items-center
                mt-10 md:mt-0
            "
      :class="{
        'col-span-7 md:self-end md:pb-8 xl:pb-12': position < 3,
        'md:self-center md:py-0 xl:py-10': position === 3
      }"
    >
      <illustration
        name="fiche_de_poste"
        class="
                    hidden md:block 
                    left-0 bottom-3 md:bottom-18 xl:bottom-16 lg:left-10 xl:left-3 xxl:left-14 2xl:left-28
                    md:transform md:scale-80 lg:scale-85 xl:scale-100 xxl:scale-110 2xl:scale-x-125
                "
        :class="{
          'absolute': position < 3,
        }"
      />
    </div>
    <!-- Liste Job description -->
    <div 
      class="
                flex flex-col space-y-4 
            "
      :class="{
        'md:pr-5 w-full': position < 3,
        'col-span-full md:p-5': position === 1,
        'col-span-5 md:mt-5': position === 2,
        'bg-white col-span-full md:py-5 md:rounded-xl md:shadow-lg md:px-5 md:m-2': position === 3,
      }"
    >
      <div 
        class="
                    text-center md:text-left
                    text-2xl md:text-xl xl:text-2xl 
                "
      >
        Fiches de poste
      </div>

      <div 
        v-if="listDescs && listDescs.length > 0" 
        class="
                            overflow-y-auto hide-scroll-bar 
                            h-60 md:h-44 xl:h-60
                        "
      >
        <div 
          v-for="(desc, i) in listDescs" 
          :key="i+'M'" 
          class="
                        odd:bg-indigo-100 odd:bg-opacity-50 grid grid-cols-12 gap-4 items-center 
                        p-4 md:p-2.5 xl:p-3
                    "
        >
          <div class="col-span-9 text-gray-600 text-base-0 font-normal">
            {{ desc.name }}
          </div>
          <div 
            class="col-span-3"
            title="Modifier le modèle de page"
          >
            <div 
              class="text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center cursor-pointer"
              @click="showJobDesc(desc.id)"
              @click.stop
            >
              <icon
                v-if="$can(constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER)"
                name="edit"
                class="md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600"
                label="Modifier la fiche de poste"
              />
              <icon 
                v-else 
                name="eye" 
                class="md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600"
                label="Visualiser la fiche de poste" 
              />
            </div>
          </div>
        </div>
      </div>
      <div 
        v-else
        class="text-center text-gray-600 flex items-center justify-center px-5"
        :class="{
          'h-64 md:h-2/3': position < 3,
          'h-64 md:h-44 xl:h-60': position === 3
        }" 
      >
        <p>Vous n'avez pas de fiche de poste dans votre bibliothèque personnelle.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './../Icon';
import Constants from './../../constants';
import Illustration from '../Illustration.vue';

export default {
  components:{
    Icon,
    Illustration
  },

  props:{
    listDescs:{
      type:Array,
      required:false,
      default:[],
    },

    position:{
      type: Number,
      required: false,
      default:1,
    }
  },

  data(){
    return {
      constants: Constants,
    };
  },

  methods:{
    showJobDesc(id){
      this.$emit('showJobDesc', id);
    },
  }
};
    
    
</script>